import React from 'react'
import Navbar from './Navbar';
import Typewriting from './Typewriting';
export default function Author() {
  return (
    <>
      <Navbar />
      
      <div className="wrapper3">
        <br />
        <div className='pic' style={{marginTop:"30px",marginLeft:"70px"}}>
          <img src={require('./imraan1.jpg')} alt="" style={{borderRadius: "50%"}} />
          <br />
          <br />
          <div className="text-type" style={{fontWeight:"bolder",fontFamily:"monospace",fontSize:"25px",marginLeft:"-10px"}}>
            <h2>Hey! I'm Imraan <br /> </h2>
            <Typewriting/>
            
          </div>
          
          <p style={{align:"centre",marginLeft:"-60px",fontSize:"20px"}}>and a BCA final year student at the  time of creating this site. <br /> I hope students make full use of this site. Moreover, you too can 
           contribute to this project. <br /> Just go to my <a href="https://github.com/Imraan002/inotes" rel="noopener noreferrer" target="_blank">GitHub</a> account and start adding new features. Good Luck💖</p> 
        </div>
          
      </div>

    </>
  )
}
